module.exports = __webpack_public_path__ + "img/reload-white.0ee4c420.svg";